// extracted by mini-css-extract-plugin
export default {"sort":"Home_sort__o6M2E"};